import { render, staticRenderFns } from "./PortalTimeline.vue?vue&type=template&id=afa94cb8&scoped=true&"
import script from "./PortalTimeline.vue?vue&type=script&lang=js&"
export * from "./PortalTimeline.vue?vue&type=script&lang=js&"
import style0 from "./PortalTimeline.vue?vue&type=style&index=0&id=afa94cb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa94cb8",
  null
  
)

export default component.exports